// ProgressBar.js
import { Stack } from '@mui/material';
import React from 'react';
import './Product.css';

const Product = ({showValue = true, value, product}) => {
    return (
        <Stack direction={'row'} justifyContent={'space-between'} marginLeft={'4px'} marginRight={'4px'} >
        {showValue && (
        <p style={{}}>{value}</p>
        )}
     
        <p style={{ textAlign: showValue ? 'end' : 'center', fontFamily: 'Raleway', maxWidth: showValue ? '348px' : null}}>{product}</p>
        </Stack> 
    );
};

export default Product;
